import gql from 'graphql-tag'
import client from '@stores/apollo'

interface ImportEmployeeMapping {
  avatar_url: string
  badge: string
  cost_center_name: string
  department_name: string
  email: string
  employment_type: string
  end_date: string
  external_id: string
  first_name: string
  initial_assignment: string
  last_name: string
  location: string
  name: string
  phone: string
  reporting_to: string
  slack_handle: string
  start_date: string
  sub_cost_center_name: string
  team_name: string
  title: string
  workplace_group_name: string
}

interface IPayload {
  data: {
    viewer: {
      company: {
        mapping: {
          employeeMapping: ImportEmployeeMapping
        }
      }
    }
  }
}

export default function mapping(): Promise<ImportEmployeeMapping> {
  return client.gql.query({ query }).then(
    ({
      data: {
        viewer: {
          company: {
            mapping: { employeeMapping },
          },
        },
      },
    }: IPayload) => employeeMapping
  )
}

const query = gql`
  query EmployeeImportMappings {
    viewer {
      company {
        mapping {
          employeeMapping {
            avatar_url
            badge
            cost_center_name
            department_name
            email
            employment_type
            end_date
            external_id
            first_name
            initial_assignment
            last_name
            location
            name
            phone
            reporting_to
            slack_handle
            start_date
            sub_cost_center_name
            team_name
            title
            workplace_group_name
          }
        }
      }
    }
  }
`
